module.exports = __webpack_public_path__ + "static/outback-2a6f4fd3f3177562f7d9529abae2415d.png";